// Tour progress, kept per seller. This is the only place that knows where it is stored, so it can be moved to a
// backend API later without touching the tour screens.
//
// Stored shape (one record per seller):
//   { userId, portal: "vendor", role, welcomeSeen, tours: { [tourId]: { status, currentStep, totalSteps, completedAt } } }
// status: "in_progress" | "completed"   (a tour with no record is "not started")

import { readStoredUser } from "../menuRoutes";

const PORTAL = "vendor";

const identity = () => {
  const u = readStoredUser() || {};
  return {
    userId: u.id || u._id || u.userId || u.sellerId || sessionStorage.getItem("userId") || u.email || "anonymous",
    role: "vendor",
  };
};

const keyFor = () => `tvfm_tour:${PORTAL}:${identity().userId}`;

const read = () => {
  const { userId, role } = identity();
  try {
    const raw = localStorage.getItem(keyFor());
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") return { ...parsed, tours: parsed.tours || {}, role };
    }
  } catch {}
  return { userId, portal: PORTAL, role, welcomeSeen: false, tours: {} };
};

const write = (data) => {
  try { localStorage.setItem(keyFor(), JSON.stringify(data)); } catch {}
};

export const getProgress = () => read();

export const getTourProgress = (tourId) => read().tours[tourId] || null;

export const saveTourProgress = (tourId, { currentStep, totalSteps }) => {
  const data = read();
  const prev = data.tours[tourId];
  if (prev && prev.status === "completed") return; // a finished tour stays finished until it is reset
  data.tours[tourId] = { status: "in_progress", currentStep, totalSteps, completedAt: null };
  write(data);
};

export const completeTour = (tourId, totalSteps) => {
  const data = read();
  data.tours[tourId] = { status: "completed", currentStep: totalSteps, totalSteps, completedAt: new Date().toISOString() };
  write(data);
};

export const resetTour = (tourId) => {
  const data = read();
  delete data.tours[tourId];
  write(data);
};

export const resetAllTours = () => {
  const data = read();
  data.tours = {};
  write(data);
};

export const isWelcomeSeen = () => !!read().welcomeSeen;

export const markWelcomeSeen = () => {
  const data = read();
  data.welcomeSeen = true;
  write(data);
};
